// extracted by mini-css-extract-plugin
export default {"others":"ProjectsArea_others__iod1X","projectsContainer":"ProjectsArea_projectsContainer__IIqWa"};